export function getFullName(names: (string | null)[] | null): string {
  if (!names) {
    return "";
  }

  const validNames = names.filter((name) => name && name.trim());

  if (validNames.length === 0) {
    return "";
  }

  return validNames.join(" ");
}

/**
 * Will return only the first and last initial for given set of names.
 * If only one valid name exists, then a single initial is returned.
 * (e.g. `['Emiton', 'Get', 'Swole', 'Alves']` -> `EA`)
 */
export function getFirstAndLastInitials(
  names: (string | null)[] | null,
): string {
  if (!names) return "";

  const validNames = names.filter((name) => name && name.trim());

  if (validNames.length === 0) return "";
  if (validNames.length === 1) return validNames[0][0].toUpperCase();

  const [first, ...rest] = validNames;
  const last = rest[rest.length - 1];

  return (first[0] + last[0]).toUpperCase();
}
